import { Observable } from 'rxjs'

export abstract class MbCheckoutReviewPricesAdapter {

  abstract load (cartID: string): Observable<any>
}
